import { extractQueryState } from "@shared/utils/extractQueryState";
import { useQuery } from "@tanstack/react-query";
import { LearningCenterVideo } from "./learning-center.store";
import { learningCenterApi } from "./learning-center-api";

const GET_LEARNING_CENTER_LOOM_VIDEOS = "learning-center-loom-videos";

type Props = {
  enabled: boolean;
  onSuccess: (data: LearningCenterVideo[]) => void;
};

const CACHE_TIME_IN_MS = 1000 * 60 * 1; // 1 hour

export const useGetLearningCenterLoomVideos = (props: Props) => {
  const { onSuccess, enabled } = props;
  const query = useQuery({
    queryKey: [GET_LEARNING_CENTER_LOOM_VIDEOS],
    queryFn: async () => {
      try {
        const response = await learningCenterApi.loadVideos();
        onSuccess(response);
        return response;
      } catch (e) {
        console.error(`Error trying to fetch the loom videos`, e);
        throw e;
      }
    },
    enabled,
    refetchOnWindowFocus: false,
    gcTime: CACHE_TIME_IN_MS,
    staleTime: CACHE_TIME_IN_MS,
  });

  return extractQueryState(query);
};
